<template>
  <w-sliding-popup ref="userSlidingPopup" :title="title" width="800px" :append-to-body="true" @close="close">
    <div slot="content">
      <el-row type="flex" justify="space-between">
        <div class="back-title title-bar">
          <i class="el-icon-back c-pointer mr-4" @click="close"></i>작업 담당자 일괄등록
        </div>
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper ref="managerTable" border :data="tableData" :columns="columns" :column-default="columnDefault" remote pagination :total="total" :show-custom-header="true" :show-search-tool="showSearchTool"
        @selection-change="handleSelectionChange" @condition-change="loadData" style="width:100%;"></el-table-wrapper>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button size="large" type="solid" @click="addManagerList" class="mr-r4">등록</el-button>
      <el-button size="large" type="default" @click="close">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import { find, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import workApi from '@/api/work/work';

export default {
  name: 'WManagerListSlidingPopup',
  props: {
    title: {
      type: String,
    },
    managerList: {
      type: Array,
    },
  },
  data() {
    return {
      tableData: [],
      showSearchTool: false,
      total: null,
      columnDefault,
      columns: [
        { type: 'selection' },
        { prop: 'managerId', label: 'ID', sortable: true, searchable: true, remoteProp: 'm.manager_id', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'managerName', label: '이름', sortable: true, searchable: true, remoteProp: 'm.manager_name', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'managerTypeName', label: '역할', sortable: true, searchable: true, remoteProp: 'mangertype.basicinfo_subname', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'associationName', label: '소속', sortable: true, searchable: true, remoteProp: 'association.basicinfo_subname', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'departmentName', label: '부서', sortable: true, searchable: true, remoteProp: 'department.basicinfo_subname', formatter: this.getTableValueAfterCheckEmpty },
        { prop: 'mobileNumber', label: '모바일', sortable: true, searchable: true, remoteProp: 'm.mobile_number', formatter: this.getTableValueAfterCheckEmpty },
      ],
      selectedManagerList: [],
    };
  },
  methods: {
    open() {
      this.$refs.userSlidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.$refs.userSlidingPopup.visible = false;
      this.showSearchTool = false;
    },
    loadData() {
      const tableParams = this.$refs.managerTable.getParameter();
      workApi.getManagerList(tableParams).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
          const managerTable = this.$refs.managerTable.$children[0];
          this.$nextTick(() => {
            forEach(this.managerList, (manager) => {
              managerTable.toggleRowSelection(find(this.tableData, ['managerId', manager.managerId]));
            });
          });
        }
      });
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author kimjy
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} value
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    handleSelectionChange(selectedManager) {
      this.selectedManagerList = selectedManager;
    },
    /**
     * '등록' 버튼 클릭, 작업 담당자 추가
     * @author kimjy
     */
    addManagerList() {
      this.$emit('add-manager-list', this.selectedManagerList);
      this.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/work/popup/components/ManagerListSlidingPopup.vue